module.exports = __webpack_public_path__ + "media/images/flags/1x1/sgp-142ba2dedf78f860a4dd39b56da8615b.svg";